// extracted by mini-css-extract-plugin
export default {"tooltipTrigger":"HomePage_tooltipTrigger__tCoEu"};